import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-epic-and-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.epic.and.workstream',
    description: 'Chart view of change impacts by epic and workstream',
    name: 'Change Impacts by Epic and Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
